module.exports = __webpack_public_path__ + "static/media/volunteer-sadie.faf59b21.jpg";